import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import { H2 } from 'foundations-components/transitional/components/H2';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import PlaylistNavigationDropdown from '../../playlistContent/components/PlaylistNavigationDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LearningContentPageHeader = ({
  title,
  item,
  children,
  playlist,
  playlistProgress
}) => {
  const {
    isDesktop
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    backgroundColor: "fill-surface-default",
    borderColor: "border-core-subtle",
    borderRadius: "300",
    borderStyle: "solid",
    borderWidth: "100",
    flexDirection: "row",
    flexWrap: "nowrap",
    inlineSize: "100%",
    insetBlockStart: "0",
    margin: "0",
    minBlockSize: isDesktop ? '76px' : '60px',
    paddingBlock: "400",
    paddingInline: isDesktop ? '1000' : '300',
    position: "sticky",
    zIndex: 2,
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      flexGrow: 1,
      children: [item && !!item.playlistId && /*#__PURE__*/_jsx(View, {
        marginBlock: "200",
        children: /*#__PURE__*/_jsx(PlaylistNavigationDropdown, {
          item: item,
          playlist: playlist,
          playlistProgress: playlistProgress
        })
      }), /*#__PURE__*/_jsx(H2, {
        flex: 1,
        margin: "0",
        typography: isDesktop ? undefined : 'body-200',
        children: title
      })]
    }), children && /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        gap: "300",
        children: children
      })
    })]
  });
};